<template>
    <v-row>
        <v-col cols="3">
            <v-list>
                <v-list-item v-for="file in files" @click="changeFile(file)" :key="file">
                    <v-list-item-title>{{ file }}</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-col>
        <v-col cols="9">
            <div class="blue-grey lighten-4 full-height">
                <pre class="full-height">{{ fileContent }}</pre>
            </div>
        </v-col>
    </v-row>
</template>

<script lang="ts">
import {Request} from "@/lib/apollo";
import {Component, Vue, Watch} from 'vue-property-decorator';

@Component({})
export default class LogFile extends Vue {
    file: string = '';
    fileContent: string = '';
    files: string[] = [];

    created() {
        this.getData();
    }

    changeFile(file: string) {
        this.file = file;
    }

    getData() {
        Request.make('/log/files', Request.GET).then((res: any) => {
            this.files = res;
        });
    }

    @Watch('file')
    onFileChange(file: string) {
        Request.make('/log/file/' + encodeURIComponent(file), Request.GET).then((res: any) => {
            this.fileContent = res;
        });
    }
}
</script>

<style scoped lang="scss">
    pre {
        padding: 1rem;
        overflow-x: auto;
        font-size: .75rem;
    }

    .full-height {
        height: 100%;
        max-height: 768px;
    }
</style>